import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import * as styles from './fallback.styles';

export const Fallback = () => {
  const handleReloadPage = () => {
    location.reload();
  };

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img
          src="https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/calculator/calculator_remote_error.png/calculator_remote_error.png"
          alt="Что-то пошло не так"
        />
      </div>
      <div className={styles.title}>
        <Typography variant="m" size="body_accent" color="text-primary">
          Что-то пошло не так
        </Typography>
      </div>
      <div className={styles.description}>
        <Typography variant="m" size="body_short" color="text-primary">
          Попробуйте обновить страницу
        </Typography>
      </div>
      <RegularButton
        data-testid="calculate-fallback-reload-button"
        rounded
        size="l"
        variant="secondary"
        onClick={handleReloadPage}>
        Обновить
      </RegularButton>
    </div>
  );
};
